import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { IModel, ServiceNowV2ObjectDataset } from 'shell-models-lib';
import { ServiceNowObjectDatasetAdapter } from './servicenow-dataset.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
export const serviceNowV2DatasetAdapts = {
    name: '*',
    properties: {
        ...tabularPropertiesCommonAdapts,
        typeProperties: {
            valueType: __IS_FABRIC_DPE__ ? '*' : undefined,
            tableName: '*'
        }
    }
};
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ServiceNowV2ObjectDataset),
    asynchronous: true,
    adapts: serviceNowV2DatasetAdapts
})
export class ServiceNowV2ObjectDatasetAdapter extends ServiceNowObjectDatasetAdapter {
    protected model(): IModel {
        return ServiceNowV2ObjectDataset.MODEL;
    }
    protected async _toResource(dataset: ServiceNowV2ObjectDataset): Promise<Model.DatasetResource> {
        const modelDatasetResource = await this._toResourceInternal(dataset, this.model().name);
        const modelDataset = this.properties(modelDatasetResource) as Model.ServiceNowV2ObjectDataset;
        const valueType =  ValueAdapter.toResource(dataset, ServiceNowV2ObjectDataset.VALUE_TYPE) ;
        modelDataset.typeProperties = _.merge(modelDataset.typeProperties, { valueType });
        return modelDatasetResource;
    }
    
    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: ServiceNowV2ObjectDataset): Promise<ServiceNowV2ObjectDataset> {
        dataset = await this._toModelInternal(modelDatasetResource, dataset, ServiceNowV2ObjectDataset.MODEL);
        const model = modelDatasetResource.properties as Model.ServiceNowV2ObjectDataset;
        if (model?.typeProperties?.valueType) {
            ValueAdapter.toModel(dataset, ServiceNowV2ObjectDataset.VALUE_TYPE, model.typeProperties.valueType);
        }
        return dataset;
    }
}
